import logo from '../../assets/images/rexoasset.png'

export default function FallbackPage() {
    return (
        <>
            <div className="d-flex justify-content-center align-items-center" style={{ backgroundColor: '#222124', height: '100vh' }}>
                <div className="text-white text-center">
                    <img src={logo} alt="lg" className="img-fluid zoom-animation" style={{ width: '50%' }} />
                </div>
            </div>
        </>
    )
}